/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable dot-notation */
const LOGROCKET_SRC = 'https://cdn.lrkt-in.com/LogRocket.min.js';
const LOGROCKET_APP_ID = 'ni2p2w/dakastar';

let loadingPromise: Promise<void> | null = null;

const loadScript = (): Promise<void> => {
	if (typeof window === 'undefined') return Promise.reject();
	if ((window as any).LogRocket) return Promise.resolve();
	if (loadingPromise) return loadingPromise;
	loadingPromise = new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = LOGROCKET_SRC;
		script.crossOrigin = 'anonymous';
		script.async = true;
		script.onload = () => resolve();
		script.onerror = () => reject();
		document.head.appendChild(script);
	});
	return loadingPromise;
};

// 把 LogRocket 從「_document 每頁無條件載入」改成「使用者按下回報 issue 才動態載入並初始化」
export const startLogRocket = (userId: string, payload: Record<string, unknown>): void => {
	loadScript()
		.then(() => {
			const { LogRocket } = window as any;
			if (!LogRocket) return;
			LogRocket.init(LOGROCKET_APP_ID);
			LogRocket.identify(userId, payload);
		})
		.catch(() => { /* 載入失敗時靜默,不影響回報流程 */ });
};
